/**
 * Validation utility functions
 * Pure functions for input validation
 * No dependencies
 */

/**
 * Validate email address format
 * @param {string} email - Email address to validate
 * @returns {boolean} True if valid email format
 *
 * @example
 * isValidEmailAddress('user@example.com') // Returns: true
 * isValidEmailAddress('invalid-email') // Returns: false
 * isValidEmailAddress('') // Returns: false
 */
export function isValidEmailAddress(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim());
}

/**
 * Whether a typed delete-confirmation matches the word. Phone keyboards append a trailing
 * space after autocompleting a word and may capitalise it, so compare trimmed and
 * case-insensitively. Use this for every type-to-confirm delete modal.
 * @param {string} text - what the user typed
 * @param {string} [word='delete'] - the required confirmation word
 * @returns {boolean}
 */
export function isDeleteConfirmation(text, word = "delete") {
    return String(text || "").trim().toLowerCase() === word;
}
